import { CopilotConfig } from '../api/types'

export const duplicateQueues = (
  queuePrompts: CopilotConfig['queuePrompts'],
): { queues: Set<string>; duplicates: Set<string> } => {
  const queues = new Set<string>()
  const duplicates = new Set<string>()

  for (const queuePrompt of queuePrompts) {
    for (const queue of queuePrompt.queues) {
      if (queues.has(queue)) {
        duplicates.add(queue)
      }
      queues.add(queue)
    }
  }
  return { queues, duplicates }
}
